var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessional01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7015 35.633C43.9773 37.2786 46.7858 39.9194 48.8358 43.2217C49.2418 43.8756 49.4448 44.2026 49.5149 44.6554C49.6576 45.5755 49.0284 46.7067 48.1714 47.0708C47.7497 47.25 47.2753 47.25 46.3265 47.25M36.2015 25.9475C39.5354 24.2908 41.8265 20.8504 41.8265 16.875C41.8265 12.8996 39.5354 9.45925 36.2015 7.80246M31.7015 16.875C31.7015 22.4669 27.1684 27 21.5765 27C15.9847 27 11.4515 22.4669 11.4515 16.875C11.4515 11.2831 15.9847 6.75 21.5765 6.75C27.1684 6.75 31.7015 11.2831 31.7015 16.875ZM5.95981 42.6113C9.547 37.2252 15.2076 33.75 21.5765 33.75C27.9454 33.75 33.6061 37.2252 37.1933 42.6113C37.9791 43.7912 38.372 44.3812 38.3268 45.1348C38.2916 45.7216 37.9069 46.44 37.4381 46.7946C36.8359 47.25 36.0077 47.25 34.3512 47.25H8.80184C7.14542 47.25 6.31721 47.25 5.71502 46.7946C5.24615 46.44 4.86149 45.7216 4.82626 45.1348C4.78103 44.3812 5.17395 43.7912 5.95981 42.6113Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional01);
export default __webpack_public_path__ + "static/media/professional01.7642310a9279909ac625d2c495ce246b.svg";
export { ForwardRef as ReactComponent };